module.exports = __webpack_public_path__ + "static/media/Manual Huawei B310.cf84c24d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual Huawei B310.pdf
// module id = 317
// module chunks = 0